import * as Types from '../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAllFilteredChargesQueryVariables = Types.Exact<{
  employee?: Types.InputMaybe<Types.Scalars['String']>;
  projectManager?: Types.InputMaybe<Types.Scalars['String']>;
  projectSupervisor?: Types.InputMaybe<Types.Scalars['String']>;
  billingAdmin?: Types.InputMaybe<Types.Scalars['String']>;
  searchText?: Types.InputMaybe<Types.Scalars['String']>;
  projectNumber?: Types.InputMaybe<Types.Scalars['Int']>;
  customerNumber?: Types.InputMaybe<Types.Scalars['String']>;
  state?: Types.InputMaybe<Types.ProjectChargeSearchFilterState>;
  billable?: Types.InputMaybe<Types.BillableFilter>;
  dateEqual?: Types.InputMaybe<Types.Scalars['String']>;
  dateBefore?: Types.InputMaybe<Types.Scalars['String']>;
  dateAfter?: Types.InputMaybe<Types.Scalars['String']>;
  afeWoPo?: Types.InputMaybe<Types.Scalars['String']>;
  officeCode?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type GetAllFilteredChargesQuery = { __typename?: 'QueryModel', projectCharges?: { __typename?: 'ProjectChargesQueryModel', allFilteredCharges?: Array<{ __typename?: 'ProjectCharge', id: number, label: string, notes?: string | null, date: string, rate: number, quantity?: number | null, timesheetQuantity?: number | null, unit?: Types.RateUnit | null, total?: number | null, state: Types.ProjectChargeState, billable: boolean, eeCode: string, glAccount?: string | null, taxable: boolean, projectId: number, canAdjust: boolean, canSplit: boolean, canPsApprove: boolean, canBaApprove: boolean, canPmApprove: boolean, canEditTaxable: boolean, canMoveProject: boolean, canPostToInvoice: boolean, canOverrideRate: boolean, lastEditNotes?: string | null, canEditDate: boolean, type: Types.ChargeType, rateSheetName?: string | null, project?: { __typename?: 'Project', name: string, number: number, budget?: number | null, afe?: string | null, po?: string | null, wo?: string | null, costCenter?: string | null, canAddCharge: boolean, status: Types.ProjectStatus, billingAdmin?: { __typename?: 'Employee', firstName: string, lastName: string, userPrincipalName: string, ultiProId: string } | null, projectManager?: { __typename?: 'Employee', firstName: string, lastName: string, userPrincipalName: string, ultiProId: string } | null, projectSupervisor?: { __typename?: 'Employee', firstName: string, lastName: string, userPrincipalName: string, ultiProId: string } | null, location?: { __typename?: 'StateCounty', state: string, county: string } | null, customer?: { __typename?: 'Customer', name: string, number?: string | null } | null, stats?: { __typename?: 'ProjectStats', totalUnbilled: number, totalBilled: number, totalPrPending: number, totalPendingApproval: number, totalPendingBilling: number, totalPmPending: number, totalNonBillable: number } | null } | null, employee?: { __typename?: 'Employee', firstName: string, lastName: string, userPrincipalName: string, ultiProId: string } | null } | null> | null } | null };


export const GetAllFilteredChargesDocument = gql`
    query GetAllFilteredCharges($employee: String, $projectManager: String, $projectSupervisor: String, $billingAdmin: String, $searchText: String, $projectNumber: Int, $customerNumber: String, $state: ProjectChargeSearchFilterState, $billable: BillableFilter, $dateEqual: String, $dateBefore: String, $dateAfter: String, $afeWoPo: String, $officeCode: String) {
  projectCharges {
    allFilteredCharges(
      employee: $employee
      projectManager: $projectManager
      projectSupervisor: $projectSupervisor
      billingAdmin: $billingAdmin
      searchText: $searchText
      projectNumber: $projectNumber
      customerNumber: $customerNumber
      state: $state
      billable: $billable
      dateEqual: $dateEqual
      dateBefore: $dateBefore
      dateAfter: $dateAfter
      afeWoPo: $afeWoPo
      officeCode: $officeCode
    ) {
      id
      label
      notes
      date
      rate
      quantity
      timesheetQuantity
      unit
      total
      state
      billable
      eeCode
      glAccount
      taxable
      projectId
      project {
        name
        number
        budget
        billingAdmin {
          firstName
          lastName
          userPrincipalName
          ultiProId
        }
        projectManager {
          firstName
          lastName
          userPrincipalName
          ultiProId
        }
        projectSupervisor {
          firstName
          lastName
          userPrincipalName
          ultiProId
        }
        location {
          state
          county
        }
        customer {
          name
          number
        }
        stats {
          totalUnbilled
          totalBilled
          totalPrPending
          totalPendingApproval
          totalPendingBilling
          totalPmPending
          totalNonBillable
        }
        afe
        po
        wo
        costCenter
        canAddCharge
        status
      }
      employee {
        firstName
        lastName
        userPrincipalName
        ultiProId
      }
      canAdjust
      canSplit
      canPsApprove
      canBaApprove
      canPmApprove
      canEditTaxable
      canMoveProject
      canPostToInvoice
      canOverrideRate
      lastEditNotes
      canEditDate
      type
      rateSheetName
    }
  }
}
    `;

/**
 * __useGetAllFilteredChargesQuery__
 *
 * To run a query within a React component, call `useGetAllFilteredChargesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllFilteredChargesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllFilteredChargesQuery({
 *   variables: {
 *      employee: // value for 'employee'
 *      projectManager: // value for 'projectManager'
 *      projectSupervisor: // value for 'projectSupervisor'
 *      billingAdmin: // value for 'billingAdmin'
 *      searchText: // value for 'searchText'
 *      projectNumber: // value for 'projectNumber'
 *      customerNumber: // value for 'customerNumber'
 *      state: // value for 'state'
 *      billable: // value for 'billable'
 *      dateEqual: // value for 'dateEqual'
 *      dateBefore: // value for 'dateBefore'
 *      dateAfter: // value for 'dateAfter'
 *      afeWoPo: // value for 'afeWoPo'
 *      officeCode: // value for 'officeCode'
 *   },
 * });
 */
export function useGetAllFilteredChargesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllFilteredChargesQuery, GetAllFilteredChargesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllFilteredChargesQuery, GetAllFilteredChargesQueryVariables>(GetAllFilteredChargesDocument, options);
      }
export function useGetAllFilteredChargesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllFilteredChargesQuery, GetAllFilteredChargesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllFilteredChargesQuery, GetAllFilteredChargesQueryVariables>(GetAllFilteredChargesDocument, options);
        }
export type GetAllFilteredChargesQueryHookResult = ReturnType<typeof useGetAllFilteredChargesQuery>;
export type GetAllFilteredChargesLazyQueryHookResult = ReturnType<typeof useGetAllFilteredChargesLazyQuery>;
export type GetAllFilteredChargesQueryResult = Apollo.QueryResult<GetAllFilteredChargesQuery, GetAllFilteredChargesQueryVariables>;